var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed_block",on:{"click":_vm.markInteracted}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.blockData.url,"allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }